(function () {
  "use strict";

  document.addEventListener("init", function (e) {
    const el = e.target.closest(".input-has-map");
    if (!el) return;

    const containerId = el.getAttribute("data-map");
    const container = document.getElementById(containerId);
    if (!container) return;

    if (
      container._leaflet_id ||
      el.leafletMap ||
      (window.jQuery && window.jQuery(el).data("leaflet-map"))
    ) {
      return;
    }

    let mapValue = el.value;
    let coords = null;
    let cityTriggered = false;

    const checkoutForm = document.querySelector("form.checkout");

    if (el.id === "billing_map") {
      let selectedCoords = checkoutForm
        ? checkoutForm.selectedCoordsBilling
        : null;
      if (!selectedCoords && window.jQuery && checkoutForm) {
        selectedCoords = window
          .jQuery(checkoutForm)
          .data("selected-coords-billing");
      }
      if (selectedCoords) {
        mapValue = selectedCoords;
        el.value = selectedCoords;
      }
    } else if (el.id === "shipping_map") {
      let selectedCoords = checkoutForm
        ? checkoutForm.selectedCoordsShipping
        : null;
      if (!selectedCoords && window.jQuery && checkoutForm) {
        selectedCoords = window
          .jQuery(checkoutForm)
          .data("selected-coords-shipping");
      }
      if (selectedCoords) {
        mapValue = selectedCoords;
        el.value = selectedCoords;
      }
    }

    function parseCoords(str) {
      if (typeof str === "string" && str.indexOf(",") !== -1) {
        let parts = str.split(",").map(Number);
        if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
          return parts;
        }
      }
      if (Array.isArray(str) && str.length === 2) {
        let parts = str.map(Number);
        if (!isNaN(parts[0]) && !isNaN(parts[1])) {
          return parts;
        }
      }
      return null;
    }

    coords = parseCoords(mapValue);

    if (!coords && typeof NS_OBJ !== "undefined" && NS_OBJ.checkout_location) {
      coords = parseCoords(NS_OBJ.checkout_location);
    }

    if (
      !coords &&
      typeof negarshop_addresses_obj !== "undefined" &&
      negarshop_addresses_obj.default_coords
    ) {
      coords = parseCoords(negarshop_addresses_obj.default_coords);
    }

    if (!coords) {
      coords = [35.6892, 51.389];
      cityTriggered = true;
    }

    if (typeof L === "undefined") return;

    let map = L.map(containerId, {
      center: coords,
      dragging: true,
      zoom: 14,
    });
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap",
    }).addTo(map);
    let marker = new L.marker(coords, {
      draggable: true,
      autoPan: true,
    }).addTo(map);

    if (cityTriggered) {
      const billingCity = document.getElementById("billing_city");
      const shippingCity = document.getElementById("shipping_city");
      if (billingCity)
        billingCity.dispatchEvent(new Event("change", { bubbles: true }));
      if (shippingCity)
        shippingCity.dispatchEvent(new Event("change", { bubbles: true }));

      const form = el.closest("form");
      if (form) {
        form.querySelectorAll('select[id*="city"]').forEach((sel) => {
          sel.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }
    }

    el.leafletMap = map;
    el.leafletMarker = marker;
    if (window.jQuery) {
      window.jQuery(el).data("leaflet-map", map);
      window.jQuery(el).data("leaflet-marker", marker);
    }

    function updateStoredCoords(val) {
      if (el.id === "billing_map") {
        if (checkoutForm) checkoutForm.selectedCoordsBilling = val;
        if (window.jQuery && checkoutForm) {
          window.jQuery(checkoutForm).data("selected-coords-billing", val);
        }
      } else if (el.id === "shipping_map") {
        if (checkoutForm) checkoutForm.selectedCoordsShipping = val;
        if (window.jQuery && checkoutForm) {
          window.jQuery(checkoutForm).data("selected-coords-shipping", val);
        }
      }
    }

    map.on("click", (e) => {
      marker.setLatLng(e.latlng, { draggable: "true" });
      let val = e.latlng.lat + "," + e.latlng.lng;
      el.value = val;
      updateStoredCoords(val);
    });
    marker.on("move", () => {
      let val = marker.getLatLng().lat + "," + marker.getLatLng().lng;
      el.value = val;
      updateStoredCoords(val);
    });

    el.addEventListener("change", function () {
      let val = el.value;
      updateStoredCoords(val);
      if (val && val.split(",").length === 2) {
        let coords = val.split(",").map(Number);
        let currentLatLng = marker.getLatLng();
        if (
          Math.abs(currentLatLng.lat - coords[0]) > 0.00001 ||
          Math.abs(currentLatLng.lng - coords[1]) > 0.00001
        ) {
          marker.setLatLng(coords);
          map.setView(coords, map.getZoom());
        }
      }
    });
  });

  function initCheckoutCities() {
    if (
      typeof negarshop_addresses_obj === "undefined" ||
      !negarshop_addresses_obj.checkout_iran_cities
    ) {
      return;
    }

    const citiesMap = negarshop_addresses_obj.cities;

    function updateCityField(type) {
      const wrapper = document.querySelector(
        ".woocommerce-" + type + "-fields, ." + type + "-fields",
      );
      if (!wrapper) return;

      const stateField = wrapper.querySelector("#" + type + "_state");
      const cityInput = wrapper.querySelector(
        'input[name="' + type + '_city"], input.negarshop-hidden-city-input',
      );

      if (!stateField || !cityInput) return;

      const stateCode = stateField.value;
      const provinceData = stateCode ? citiesMap[stateCode] : null;

      let citySelect = wrapper.querySelector(
        "#" + type + '_city_select, select[name="' + type + '_city"]',
      );

      if (
        provinceData &&
        provinceData.cities &&
        provinceData.cities.length > 0
      ) {
        if (!citySelect) {
          citySelect = document.createElement("select");
          citySelect.id = type + "_city_select";
          citySelect.className = "negarshop-city-select";
          cityInput.parentNode.insertBefore(citySelect, cityInput.nextSibling);
        }

        const currentVal = citySelect.value || cityInput.value;
        citySelect.innerHTML = "";
        const defaultOpt = document.createElement("option");
        defaultOpt.value = "";
        defaultOpt.textContent = "انتخاب شهر...";
        citySelect.appendChild(defaultOpt);

        provinceData.cities.forEach(function (city) {
          const opt = document.createElement("option");
          opt.value = city;
          opt.textContent = city;
          if (city === currentVal) {
            opt.selected = true;
          }
          citySelect.appendChild(opt);
        });

        cityInput.style.display = "none";
        cityInput.disabled = true;
        if (cityInput.getAttribute("name")) {
          cityInput.setAttribute(
            "data-original-name",
            cityInput.getAttribute("name"),
          );
          cityInput.removeAttribute("name");
        }
        if (cityInput.id === type + "_city") {
          cityInput.removeAttribute("id");
          cityInput.classList.add("negarshop-hidden-city-input");
        }

        citySelect.style.display = "block";
        citySelect.disabled = false;
        citySelect.setAttribute("name", type + "_city");
        citySelect.setAttribute("id", type + "_city");

        if (window.jQuery && typeof window.jQuery.fn.select2 !== "undefined") {
          window.jQuery(citySelect).select2({
            dir: "rtl",
            placeholder: "انتخاب شهر...",
          });
        }
      } else {
        if (citySelect) {
          citySelect.style.display = "none";
          citySelect.disabled = true;
          citySelect.removeAttribute("name");
          citySelect.removeAttribute("id");
          if (
            window.jQuery &&
            typeof window.jQuery.fn.select2 !== "undefined" &&
            window.jQuery(citySelect).data("select2")
          ) {
            window.jQuery(citySelect).select2("destroy");
          }
        }

        const originalName =
          cityInput.getAttribute("data-original-name") || type + "_city";
        cityInput.setAttribute("name", originalName);
        cityInput.id = type + "_city";
        cityInput.classList.remove("negarshop-hidden-city-input");
        cityInput.style.display = "block";
        cityInput.disabled = false;
      }
    }

    document.addEventListener("change", function (e) {
      const select = e.target.closest(
        "select.state_select, #billing_state, #shipping_state",
      );
      if (select) {
        const id = select.id;
        if (id === "billing_state") {
          updateCityField("billing");
        } else if (id === "shipping_state") {
          updateCityField("shipping");
        }
      }
    });

    updateCityField("billing");
    updateCityField("shipping");

    if (window.jQuery) {
      window.jQuery(document.body).on("updated_checkout", function () {
        updateCityField("billing");
        updateCityField("shipping");
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".input-has-map").forEach((el) => {
      el.dispatchEvent(new CustomEvent("init", { bubbles: true }));
    });
    initCheckoutCities();

    if (window.jQuery) {
      window.jQuery(document.body).on("updated_checkout", function () {
        document.querySelectorAll(".input-has-map").forEach((el) => {
          el.dispatchEvent(new CustomEvent("init", { bubbles: true }));
        });
      });
    }

    const addressWrapper = document.querySelector(
      ".negarshop-checkout-address-card-wrapper",
    );
    const fieldsTrigger = document.querySelector(
      ".checkout-form-fields-trigger",
    );
    if (addressWrapper && fieldsTrigger) {
      const fieldsWrapper = document.querySelector(
        ".checkout-form-fields-wrapper",
      );
      if (fieldsWrapper) fieldsWrapper.classList.add("cropped");
      fieldsTrigger.style.display = "block";
    }
  });

  document.addEventListener("click", function (e) {
    const triggerBtn = e.target.closest(".checkout-form-fields-trigger button");
    if (triggerBtn) {
      e.preventDefault();
      const parent = triggerBtn.parentNode;
      if (parent) parent.style.display = "none";
      const fieldsWrapper = document.querySelector(
        ".checkout-form-fields-wrapper",
      );
      if (fieldsWrapper) fieldsWrapper.classList.remove("cropped");
    }
  });

  if (
    typeof window.StickySidebar !== "undefined" &&
    document.querySelector(".checkout-review-column")
  ) {
    new window.StickySidebar(".checkout-review-column", {
      topSpacing: 30,
      bottomSpacing: 30,
      minWidth: 992,
    });
  }
})();
